import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/sampleRangeProportion";
import {ComponentProps, Fragment, useState} from "react";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Divider from "../../components/Divider";
import {Button, message, Popconfirm, Space} from "antd";
import {useRequest} from "ahooks";
import UploadModal from "../../components/UploadModal";
import useFormModal from "../../utils/useFormModal";
import ModifyModal from "./component/ModifyModal";
import withAuth from "../../utils/withAuth";


const ImportButton = withAuth('import', Button);
const EditFragment = withAuth('edit', Fragment);
const DeletePopconfirm = withAuth('delete', Popconfirm);


function RangeProportion(props: ComponentProps<any>) {

    const {tableProps, search, form, refresh} = useAntTable(api.getRangeProportions, {});
    const [importModalVisible, setImportModalVisible] = useState(false);
    const {loading: loadingImport, run: runImport} = useRequest(api.importExcel, {
        manual: true,
        onSuccess(res) {
            message.success('上传成功');
            setImportModalVisible(false);
            refresh();
        }
    });
    const {loading: loadingUpdate, run: runUpdate} = useRequest(api.update, {
        manual: true,
        onSuccess(res) {
            setVisible(false);
            refresh();
        }
    })
    const {modalProps, setVisible} = useFormModal({
        onOk(record: any) {
            runUpdate(record);
        }
    });

    const {run: onDelete} = useRequest(api.deleteProportion, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'description',
            key: 'description',
            title: '描述'
        },
        {
            dataIndex: 'reagentCode',
            key: 'reagentCode',
            title: '试剂商品编号'
        },
        {
            dataIndex: 'reagentName',
            key: 'reagentName',
            title: '试剂名称'
        },
        {
            dataIndex: 'fromQty',
            key: 'fromQty',
            title: '从'
        },
        {
            dataIndex: 'toQty',
            key: 'toQty',
            title: '到'
        },
        {
            dataIndex: 'calibrationCode',
            key: 'calibrationCode',
            title: '校准商品'
        },
        {
            dataIndex: 'calibrationName',
            key: 'calibrationName',
            title: '校准名称'
        },
        {
            dataIndex: 'calibrationQty',
            key: 'calibrationQty',
            title: '校准数量'
        },
        {
            dataIndex: 'qualityControlCode',
            key: 'qualityControlProducts',
            title: '质控商品'
        },
        {
            dataIndex: 'qualityControlName',
            key: 'qualityControlName',
            title: '质控名称'
        },
        {
            dataIndex: 'qualityControlQty',
            key: 'qualityControlQty',
            title: '质控数量'
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(v, r: any) {
                return <Divider>
                    <EditFragment><a onClick={() => setVisible(true, r)}>编辑</a></EditFragment>
                    <DeletePopconfirm title={'是否确认删除？'} onConfirm={() => onDelete(r.id)}><a
                        style={{color: 'var(--danger-color)'}}>删除</a></DeletePopconfirm>
                </Divider>
            }
        }
    ];

    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'description',
            title: '描述',
            search: {
                colSpan: 8
            }
        },
        {
            dataIndex: 'reagentCode',
            title: '试剂编号',
            search: {
                colSpan: 8
            }
        }
    ];

    const toolbar = (
        <Space>
            <ImportButton type={"primary"} onClick={() => setImportModalVisible(true)}>导入</ImportButton>
        </Space>
    )

    return <PageHeaderLayout>
        <StandardTable {...tableProps} submit={search.submit} columns={columns} form={form} search={search}
                       extSearchColumns={searchColumns} toolbar={toolbar}/>
        <ModifyModal {...modalProps}/>
        <UploadModal key={'importModal'}
                     open={importModalVisible}
                     onUpload={runImport}
                     title={'导入'}
                     template={'/template/校准和质控固定比例导入模板.xlsx'}
                     confirmLoading={loadingImport}
                     onCancel={() => setImportModalVisible(false)}/>
    </PageHeaderLayout>
}

export default RangeProportion;
